export const ALLOCATIONS = {
    UNALLOCATED: '',
    CONTROL: '1',
    TEST_B: '2',
    TEST_C: '3',
    TEST_D: '4',
};
